class Lead {
  facebook = null;
  work = null;
  salesperson = null;
  phone = null;
  address = null;
  priority = null;
  channel = null;
  estimatedsell = null;
  region = null;
  oldcompanyratio = null;
  oldcompanyname = null;
  marketeruserid = null;
  contacted = null;
  status = null;
  note = null;
  date = new Date();

  createdby = null;
  updatedby = null;
}
export default Lead;
